var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleNeutralCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "single-neutral-circle 1",
    clipPath: "url(#clip0_1196_7840)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845885 10.121 0.00229405 8 0ZM12.0893 11.9333C12.0444 12.0048 11.982 12.0637 11.9081 12.1045C11.8342 12.1453 11.7511 12.1667 11.6667 12.1667H4.33334C4.24897 12.1666 4.16599 12.1452 4.09211 12.1045C4.01824 12.0638 3.95587 12.005 3.91082 11.9336C3.86577 11.8623 3.83951 11.7807 3.83447 11.6965C3.82943 11.6123 3.84578 11.5282 3.882 11.452C4.25113 10.6721 4.83411 10.0131 5.56312 9.55164C6.29213 9.09015 7.1372 8.84516 8 8.84516C8.86281 8.84516 9.70787 9.09015 10.4369 9.55164C11.1659 10.0131 11.7489 10.6721 12.118 11.452C12.1543 11.5281 12.1707 11.6122 12.1657 11.6964C12.1607 11.7805 12.1344 11.8621 12.0893 11.9333ZM8 2.9C8.48786 2.9 8.96477 3.04467 9.37041 3.31571C9.77605 3.58675 10.0922 3.97199 10.2789 4.42271C10.4656 4.87344 10.5145 5.3694 10.4193 5.84789C10.3241 6.32638 10.0892 6.76589 9.7442 7.11086C9.39923 7.45583 8.95971 7.69076 8.48123 7.78594C8.00274 7.88111 7.50678 7.83227 7.05605 7.64557C6.60533 7.45887 6.22009 7.14271 5.94905 6.73707C5.678 6.33143 5.53334 5.85453 5.53334 5.36667C5.53334 4.71247 5.79322 4.08506 6.25581 3.62247C6.7184 3.15988 7.3458 2.9 8 2.9Z",
    fill: "#94A6B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1196_7840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleNeutralCircle1);
export default __webpack_public_path__ + "static/media/single-neutral-circle 1.16bee7b427b7fcb212c802ad30742698.svg";
export { ForwardRef as ReactComponent };